import { render, staticRenderFns } from "./FerryDetail.vue?vue&type=template&id=bfcebdba"
import script from "../../controllers/ferry/ferry-detail.js?vue&type=script&lang=js&external"
export * from "../../controllers/ferry/ferry-detail.js?vue&type=script&lang=js&external"
import style0 from "./FerryDetail.vue?vue&type=style&index=0&id=bfcebdba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports